var exports = {
  "a": "Box__TVysfu",
  "w": "Box_1__WgoNS_",
};

module.exports = exports;
